<template>
  <div class='peoplePageContainer' ref='how_page'>
    <modals-container/>
    <div class='PageHeader'>
      <div class='PageHeaderRollsRoyceLogo'></div>
      <div class='PageHeaderTitleContainer'>People</div>
      <div class='PageHeaderButtonContainer'>
        <button class='AcronymsButton' id="show-modal" :class="{ AcronymsOnState: acronymsState }" @click="showAcronyms"></button>

        <router-link :to="{ name: 'HomePage' }">
          <button class='NavBackButton'></button>
        </router-link>
      </div>
    </div>
      <div class="pageContent">
        <div class="pageContent">
          <slides-component :slide-data="slides" ></slides-component>
        </div>
      </div>
  </div>

</template>

<script>
import SlidesComponent from "@/components/SlidesComponent";
import AcronymsModal from "@/components/modals/AcronymsModal";
export default {

  data () {
    return {
      acronymsState: false,
      slides:{
        1: {
          title: "People",
          summary: "All organisations need skilled and experienced people to operate their manufacturing processes, the key principles are:",
          points: [
            "Each process needs a nominated technical authority",
            "Each process needs an owner, responsible for continuous improvement and process performance",
            "All roles must be clearly defined in the company management system",
            "People must understand their role(s) and responsibilities",
            "People must be suitably trained and competent for their role."
          ],
          image:"assets/images/People/01_People.jpg"
        },
        2:{
          title: "Ownership",
          summary: "The process owner is key to good process performance.",
          points: [
            "A process owner is responsible for ensuring that a process " +
            "is operated effectively and is continuously improved.",
            "The process owner doesn’t have to do everything themselves, " +
            "they should use the available networks to implement best practice and learn from others’ lessons.",
            "A process owner may own more than one process.",
            "The process owner role doesn’t need to be linked to company hierarchy or grades, it is just about having " +
            "clear accountability for each process."
          ],
          image:"assets/images/People/02_Ownership.jpg"
        },
        3:{
          title: "Training",
          summary: "Everyone working with a manufacturing process must receive appropriate training to ensure " +
              "they have sufficient understanding of the process.  " +
              "Training should be recorded and refreshed at regular intervals.  Typically, training would include:",
          points: [
              "Process operators should receive comprehensive theoretical and practical training on how to " +
              "operate the process and equipment.  This should include a competency assessment.",
              "Process Engineers should receive training that explains the engineering principles of a process.  " +
              "Where available, this should lead to a recognised qualification.",
              "Designers should receive appreciation training so that they have sufficient process knowledge " +
              "to design for manufacture."
          ],
          image:"assets/images/People/03_Training.jpg"
        }
      }
    }
  },

  created() {

  },

  watch: {

  },

  methods: {
    showAcronyms() {
      // Open Acronyms Modal 'LightOut' Box
      this.$modal.show(AcronymsModal, {}, {
        width: "100%",
        height: "auto"
      },{
        'before-close': () => { this.acronymsState = !this.acronymsState }
      });

      this.acronymsState = !this.acronymsState
    }
  },
  components:{
    SlidesComponent
  }

}
</script>
<style scoped>
.pageContent{
 margin: 50px 0 0 42px;
  font-family: RRPioneer;

}
.title{
  color: #271BCB;
  font-size: 28px;
}
.summary{

}
</style>